import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const LogoutModel = ({ openDialog, setOpenDialog }) => {
    
    const navigate = useNavigate();
    
    const onLogout = () => {
        sessionStorage.clear();
        navigate("/");
    }

    return (
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle>Sign Out</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to sign out?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                <Button
                    onClick={() => {
                        setOpenDialog(false);
                        onLogout();
                    }}
                    color="error"
                    variant="contained"
                >
                    Sign Out
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default LogoutModel